var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "r-panel",
    {
      attrs: { title: _vm.title, button_add: true },
      on: { click_add: _vm.click_add },
    },
    [
      _c("mapkind-table", {
        ref: "table",
        attrs: { items: _vm.values, title: _vm.title, toolbar: false },
        on: {
          "update:items": function ($event) {
            _vm.values = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }